module.exports = "pegasus/assets/themelp1/webinar/102.png";